export default __webpack_public_path__ + "static/media/icn-circle-plus.eeb592a0.svg";